module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("我的菜单")]), _vm._v(" "), _vm._l((_vm.menus), function(menu, index) {
    return _c('li', {
      staticClass: "treeview"
    }, [(menu.url != '#') ? _c('router-link', {
      attrs: {
        "to": {
          path: menu.url
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-align-justify"
    }), _vm._v(" "), _c('span', {
      staticClass: "page"
    }, [_vm._v(_vm._s(menu.name))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right-container"
    })]) : _c('a', {}, [_c('i', {
      staticClass: "fa fa-list-ul"
    }), _vm._v(" "), _c('span', {
      staticClass: "page"
    }, [_vm._v(_vm._s(menu.name))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right-container"
    }, [_c('i', {
      staticClass: "fa fa-angle-left pull-right"
    })])]), _vm._v(" "), (menu.subMenu != null) ? _c('ul', {
      staticClass: "treeview-menu"
    }, _vm._l((menu.subMenu), function(sub) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": {
            path: sub.url
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-list-alt"
      }), _vm._v(" "), _c('span', {
        staticClass: "page"
      }, [_vm._v(_vm._s(sub.name))])])], 1)
    }), 0) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71071273!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 1762
// module chunks = 2